import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PermissionService } from '../_services';

@Injectable({
  providedIn: 'root'
})
export class SelfServiceGuard implements CanActivate {

  constructor(private router: Router, private permissionService: PermissionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) {
      return of(this.router.createUrlTree(['/login']));
    }

    // JS-1920 follow-up (2026-11-03): tightened from the any-of-6 module check to the
    // view-only subset (View All / View Own). A user with only create/edit/delete can't
    // land on anything useful from the dashboard — hide the entry point entirely.
    // Broader surfaces that still need any-of-6 keep calling canAccessSelfServiceModule.
    return this.permissionService.canViewSelfServiceProjects().pipe(
      map((allowed) => {
        if (allowed) {
          return true;
        }
        const fallback = currentUser.role && currentUser.role.includes('client')
          ? '/client-dashboard'
          : '/project';
        return this.router.createUrlTree([fallback]);
      }),
      catchError(() => of(this.router.createUrlTree(['/login'])))
    );
  }
}
